import { Component } from '@angular/core';
import {AccordionModule} from "primeng/accordion";
import {DockModule} from "primeng/dock";
import {Router} from "@angular/router";

@Component({
  selector: 'app-admin-side-menu',
  standalone: true,
    imports: [
        AccordionModule,
        DockModule
    ],
  templateUrl: './admin-side-menu.component.html',
  styleUrl: './admin-side-menu.component.css'
})
export class AdminSideMenuComponent {


    constructor(public route: Router,) {
    }

    goToPage(routPath: string) {
        this.route.navigate(['/admin/'+routPath]);
    }


}
